
import React from 'react';
import { Field, setNestedObjectValues } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback, Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';
import Camera, { IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import SignatureCanvas from 'react-signature-canvas'; // https://github.com/agilgur5/react-signature-canvas

class Page6DokumenPendukung extends React.Component {

    constructor(props) {
        super(props);
        this.state = { signatureCanvasOpen: false, signatureDataUrl: localStorage.getItem('signatureDataUrl') || null };
        this.openSignatureModal = this.openSignatureModal.bind(this);
        this.onSpecimenClick = this.onSpecimenClick.bind(this);
        this.onPhotoKTPClick = this.onPhotoKTPClick.bind(this);
        this.onPhotoCoverTabunganClick = this.onPhotoCoverTabunganClick.bind(this);
        this.onPhotoNPWPClick = this.onPhotoNPWPClick.bind(this);
    }

    openSignatureModal = () => {
        this.setState({ signatureCanvasOpen: true });
    }

    onSpecimenClick = (e) => {
        alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.' +
            '\n3. Tidak boleh menggunakan foto tanda tangan pada KTP ataupun buku tabungan' +
            '\n4. Pastikan melakukan tanda tangan di atas kertas putih');
        return true;
    }

    onPhotoKTPClick = (e) => {
        alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.' +
            '\n3. Pastikan posisi tulisan dapat dibaca dari kiri ke kanan, foto dan tanda tangan pada KTP harus terlihat jelas');
        return true;
    }

    onPhotoCoverTabunganClick = (e) => {
        alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.' +
            '\n3. Foto halaman yang menampilkan nomor Rekening dan nama pemilik Rekening' +
            '\n4. Apabila tidak memiliki buku tabungan dapat menggunakan QR code pada aplikasi mobile BCA (pastikan ada nomor Rekening dan nama pemilik Rekening');
        return true;
    }

    onPhotoNPWPClick = () => {
        alert('Mohon pastikan hal berikut sebelum anda mengambil foto:\n 1. Posisi Handphone tegak lurus/Potrait \n 2. Data yang diambil gambar dan tulisannya dapat terlihat dengan jelas.' +
            '\n3. Pastikan posisi tulisan dapat dibaca dari kiri ke kanan, dapat dibaca dengan jelas dan tidak terpotong');
        return true;
    }

    sigPad = () => { }

    clearSigPad = () => {
        this.sigPad.clear();
    }

    trim = (setFieldValue) => {
        console.log('trim');
        if (this.sigPad.isEmpty()) {
            this.setState({ signatureDataUrl: '', signatureCanvasOpen: false });
            localStorage.setItem('signatureDataUrl', '');
        } else {
            this.setState({
                signatureDataUrl: this.sigPad.getTrimmedCanvas()
                    .toDataURL('image/png'), signatureCanvasOpen: false
            });
            localStorage.setItem('signatureDataUrl', this.sigPad.getTrimmedCanvas().toDataURL('image/png'));
            setFieldValue('SignatureImage', this.sigPad.getTrimmedCanvas()
                .toDataURL('image/png'));
                this.props.setFieldValue('SignatureImage', this.sigPad.getTrimmedCanvas()
                    .toDataURL('image/png'));
            console.log('trim else ');
        }
    }

    render() {
        const { errors, touched, takePhoto, state, onSnapPhoto, setFieldValue, imageChange, values, isValid, onNextDokumenPendukungClick, setFieldTouched, validateForm } = this.props;
        return (
            <React.Fragment>

                <Modal isOpen={this.state.signatureCanvasOpen}>
                    <ModalBody style={{ padding: 0 }} >
                    <SignatureCanvas penColor='black'
                        canvasProps={{ width: 500, height: 500, className: 'sigCanvas' }}
                            ref={(ref) => { this.sigPad = ref }} />
                    </ModalBody>
                    <ModalFooter style={{ backgroundColor: '#f1f1f1' }}>
                        <Button color="primary" onClick={() => this.trim(setFieldValue)}>Done</Button>{' '}
                        <Button color="secondary" onClick={this.clearSigPad}>Clear</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={state.openModalPhoto}>
                    <Row>
                        <Col md="12">
                            <Camera
                                onTakePhoto={(dataUri) => { onSnapPhoto(dataUri, setFieldValue); }}
                                imageCompression={0}
                                isImageMirror={false}
                                isFullscreen={false}
                            />
                        </Col>
                    </Row>
                </Modal>

                <FormGroup tag="fieldset">
                    <legend>Dokumen Pendukung</legend>
                    <Row>
                        {/*<Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto Selfie<span className="text-danger">*</span></Label>
                                <br /><button type="button" className="btn btn-primary btn-sm" onClick={() => takePhoto('PhotoSelfie')}>Ambil Foto</button>

                                {errors.PhotoSelfie && touched.PhotoSelfie ? (
                                    <FormFeedback>{errors.PhotoSelfie}</FormFeedback>
                                ) : null}
                                <img className="img-fluid" src={state.PhotoSelfie} alt="" />
                            </FormGroup>
                        </Col>
                        */}
                        <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto KTP<span className="text-danger">*</span></Label>

                                <Input type="file" accept="image/*" id="PhotoKTP" name="PhotoKTP"
                                    onClick={() => this.onPhotoKTPClick()}
                                    onChange={(e) => imageChange(e, setFieldValue)} capture="camera"
                                    invalid={errors.PhotoKTP && touched.PhotoKTP} 
                                />

                                {errors.PhotoKTP && touched.PhotoKTP ? (
                                    <FormFeedback>{errors.PhotoKTP}</FormFeedback>
                                ) : null}
                                <img className="img-fluid" src={values.PhotoKTP} alt="" />
                            </FormGroup>
                        </Col>
                        <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto Selfie Pegang KTP<span className="text-danger">*</span></Label>
                                <br /><button type="button" className="btn btn-primary btn-sm" onClick={() => takePhoto('PhotoSelfieKTP')}>Ambil Foto</button>

                                <Input onChange={(e) => imageChange(e, setFieldValue)} type="hidden" id="PhotoSelfieKTP" name="PhotoSelfieKTP" invalid={errors.PhotoSelfieKTP && touched.PhotoSelfieKTP}  />
                                {errors.PhotoSelfieKTP ? (
                                    <FormFeedback>{errors.PhotoSelfieKTP}</FormFeedback>
                                ) : null}
                                <img className="img-fluid" src={values.PhotoSelfieKTP} alt="" />
                               {/* <Input type="hidden" id="PhotoSelfieKTP" name="PhotoSelfieKTP" value={state.PhotoSelfieKTP} />*/}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {/*
                            <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto Spesimen Tanda Tangan Diatas Kertas Putih<span className="text-danger">*</span></Label>
                                <br /><button type="button" className="btn btn-primary btn-sm" onClick={() => this.props.takePhoto('PhotoSpesimen')}>Ambil Foto</button>
                                {errors.PhotoSpesimen && touched.PhotoSpesimen ? (
                                    <FormFeedback>{errors.PhotoSpesimen}</FormFeedback>
                                ) : null}
                                <img className="img-fluid" src={state.PhotoSpesimen} alt="" />
                            </FormGroup>
                        </Col>
                        */}

                        {/* <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto Spesimen Tanda Tangan Diatas Kertas Putih<span className="text-danger">*</span></Label>
                                <br />
                                <Input type="file" accept="image/*" id="PhotoSpesimen" name="PhotoSpesimen"
                                onClick={(e) => this.onSpecimenClick(e)}
                                    onChange={(e) => imageChange(e, setFieldValue)} capture="camera"
                                />
                                {errors.PhotoSpesimen && touched.PhotoSpesimen ? (
                                    <FormFeedback>{errors.PhotoSpesimen}</FormFeedback>
                                ) : null}
                                <img className="img-fluid" src={state.PhotoSpesimen} alt="" />
                            </FormGroup>
                        </Col>
                        */}

                        <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Tanda Tangan<span className="text-danger">*</span></Label>
                                <br />
                                <button type="button" className="btn btn-primary btn-sm"
                                    onClick={() => this.openSignatureModal()}>Ambil Tanda Tangan</button>
                                <br />
                                {values.SignatureImage
                                    ? <img alt="" className="img-fluid"
                                        src={values.SignatureImage} />
                                    : null}
                                <Input type="hidden" id="SignatureImage" name="SignatureImage" invalid={errors.SignatureImage && touched.SignatureImage} />
                                {errors.SignatureImage && touched.SignatureImage ? (
                                    <FormFeedback>{errors.SignatureImage}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </Row>
                    {/*
                    <Row>

                         <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto Cover Buku Tabungan</Label>
                                <Input type="file" accept="image/*" id="PhotoSavingCover" name="PhotoSavingCover"
                                onClick={() => this.onPhotoCoverTabunganClick()}
                                    onChange={(e) => imageChange(e, setFieldValue)} />

                                <img className="img-fluid" src={state.PhotoSavingCover} alt="" />
                            </FormGroup>
                        </Col> 
                    </Row>

                    {values.NPWP != "1" ?
                    <Row>
                        <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto NPWP 
                                {(values.NPWP === "2") || (values.NPWP === "3") ?
                                    <span  className="text-danger">*</span> : null }
                                    </Label>
                                <Input type="file" accept="image/*" id="PhotoNPWP" name="PhotoNPWP"
                                onClick={() => this.onPhotoNPWPClick()}
                                    onChange={(e) => imageChange(e, setFieldValue)} capture="camera"
                                />
                                <img className="img-fluid" src={state.PhotoNPWP} alt="" />
                            </FormGroup>
                        </Col>
                    </Row>
                        : null}
                    */}
                    <div className="row">
                        <div className="col text-left">
                            {isValid}
                        </div>
                        <div className="col text-right">
                            <Button
                                type="button"
                                onClick={() => onNextDokumenPendukungClick(isValid, setFieldTouched, values, validateForm, setFieldValue)}
                                color="primary" >Selanjutnya &#8594;</Button>
                        </div>
                    </div>
                </FormGroup>
            </React.Fragment>
        )
    }
}

export default Page6DokumenPendukung;


// WEBPACK FOOTER //
// ./src/components/Page6DokumenPendukung.js